export const INIT_GET_APPOINTMENT = "APPOINTMENT::INIT_GET_APPOINTMENT";
export const RESPONSE_GET_APPOINTMENT = "APPOINTMENT::RESPONSE_GET_APPOINTMENT";
export const ERROR_GET_APPOINTMENT = "APPOINTMENT::ERROR_GET_APPOINTMENT";
export const CLEAN_GET_APPOINTMENT = "APPOINTMENT::CLEAR_GET_APPOINTMENT";
export const INIT_PUT_APPOINTMENT = "APPOINTMENT::INIT_PUT_APPOINTMENT";
export const RESPONSE_PUT_APPOINTMENT = "APPOINTMENT::RESPONSE_PUT_APPOINTMENT";
export const ERROR_PUT_APPOINTMENT = "APPOINTMENT::ERROR_PUT_APPOINTMENT";
export const CLEAN_PUT_APPOINTMENT = "APPOINTMENT::CLEAR_PUT_APPOINTMENT";
